import { View } from 'backbone.marionette';

import tmplMaintenanceDeviceItemView from './MaintenanceDeviceItemView.hbs';

const MaintenanceDeviceItemView = View.extend({
  template: tmplMaintenanceDeviceItemView,

  className: 'order-device-item-view pt-2 pb-4 px-4',

  ui: {
    quantity: '.quantity'
  },

  events: {
    'change @ui.quantity': 'onQuantityChange'
  },

  initialize() {
    // Initialize values and map for consistency
    // TODO: get default values set (may have to do this in the section view)
    this.model.set({
      productName: this.model.get('model'),
      quantity: this.model.get('quantity') || '0'
    });
  },

  onQuantityChange(e) {
    const quantity = this.ui.quantity.val();
    this.model.set('quantity', quantity);
  }
});

export default MaintenanceDeviceItemView;
